import styled from "styled-components";

const BodyWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #eeeeee;
  border-radius: 10px;
  margin: 10px;

  .documentName {
    width: 93%;
    padding: 20px 20px;
  }

  .viewButton {
    width: 7%;
    text-align: right;
    padding-right: 20px;
    border-left: 1px solid black;
    font-weight: 800;
    cursor: pointer;
  }
`;

const DocumentCard = ({ document }) => {
  return (
    <>
      <BodyWrapper>
        <div className="documentName">{document.documentName}</div>
        <div
          className="viewButton"
          onClick={() => window.open(document.documentURL)}
        >
          View
        </div>
      </BodyWrapper>
    </>
  );
};

export default DocumentCard;
